<div class="mat-elevation-z3 " style="padding: 16px">
  <dx-data-grid
              [dataSource]="gridDataSource"
              [rowAlternationEnabled]="true"
              [columnAutoWidth]="true"
              style="padding-bottom: 10px;"
              (onRowInserting)="onRowInserting($event)"
              (onRowUpdating)="onRowUpdating($event)"
              (onToolbarPreparing)="onToolbarPreparing($event)">
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-editing mode="batch"
                  [allowUpdating]="true"
                  [allowAdding]="true"
                  [useIcons]="true">
      </dxo-editing>
      <dxo-selection
          mode="multiple"
          showCheckBoxesMode="always">
      </dxo-selection>

      <dxi-column dataField="TimeTypeId" caption="{{languageService.LNG('Label.TimeType')}}" [width]="100"  >
          <dxo-lookup [dataSource]="timeTypeDataSource"
            displayExpr="Code"
            valueExpr="TimeTypeId">
          </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="TotSecondsToHH" caption="{{languageService.LNG('Label.Hours')}}" [width]="65" alignment="right">
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="TotSecondsTomm" caption="{{languageService.LNG('Label.Minutes')}}" [width]="80" alignment="left">
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
  </dx-data-grid>
</div>
